import { Colors } from "../../../../shared/theme";

export const styles = {
    section: {
        display: 'flex', 
        flexDirection: 'column',
        background: Colors.white, 
        padding: '24px 16px', 
        gap: 16, 
        borderRadius: 16 ,
        position: 'relative'
    }
}